import { motion } from "framer-motion";
import { useState } from "react";
import { Flyout } from "../flyout/Flyout";

export const Accordion = ({ i, expanded, setExpanded, element }) => {
    const isOpen = i === expanded;
    const [flyExpanded, setFlyExpanded] = useState(null);

    const accVariants = {
        open: {display: "block", opacity: 1, left: "18px"},
        closed: { opacity: 0, right: '-1300px', display: "none"},
    };

    const genSubMenu = (sub, parent) => {
        return sub.map((link, i) => {
            if (link.Flyout.length > 0) {
                return <Flyout key={i} i={i} flyExpanded={flyExpanded} setFlyExpanded={setFlyExpanded} flyElement={link} parent={parent} />
            } else {
                return <li key={i}>
                    <a href={link.Url}>{link.MenuName}</a>
                </li>
            }
           
        })
    }

    if (element.SubMenu.length > 0) {
        return <li key={i} className="top-level dropdown">
        <button className="flyout-trigger" onClick={() => setExpanded(isOpen ? false : i)}>{element.Name}</button>
            {isOpen && (
                <motion.ul 
                custom={i}
                animate={"open"} 
                exit="closed"
                variants={accVariants}
                className="mobile-flyout-menu flyout-level">
                <li>
                    <button className="flyback-trigger" onClick={() => setExpanded(isOpen ? false : i)}>&lt;&nbsp;<span>Main Menu</span></button>
                </li>
                <li className="level-overview">
                    <a href={element.Url}>{element.Name}</a>
                </li>
                {genSubMenu(element.SubMenu, element.Name)}
            </motion.ul>
            )
        }</li>
    } else {
        return <li className="top-level"><a href={element.Url}>{element.Name}</a></li>
    }
}